module.exports = __webpack_public_path__ + "media/images/admin/icons/speaker-0ffa822317565ea702579cef12faba53.svg";